import React, { useEffect, useState } from 'react'
import { useTranslation } from 'i18n'
import * as styles from '../SideBySideVideo.module.scss'

import {
  ENGINES,
  EngineId,
  getStoredEngine,
  isWebCodecsSupported,
  setStoredEngine,
} from '../lib/engines'

const EnginePicker = () => {
  const { t } = useTranslation('sideBySideVideo')
  const [engine, setEngine] = useState<EngineId>('ffmpeg')
  const webcodecs = typeof window !== 'undefined' ? isWebCodecsSupported() : false

  useEffect(() => {
    setEngine(getStoredEngine())
  }, [])

  const onSelect = (id: EngineId) => {
    setStoredEngine(id)
    setEngine(id)
  }

  return (
    <div
      className={styles.enginePicker}
      role="group"
      aria-label={t('engine.groupLabel')}
    >
      <span className={styles.enginePickerLabel}>{t('engine.label')}</span>
      {ENGINES.map(e => (
        <button
          key={e.id}
          type="button"
          className={[styles.enginePickerBtn, engine === e.id ? styles.isActive : ''].filter(Boolean).join(' ')}
          onClick={() => onSelect(e.id)}
          title={
            e.id === 'mediabunny'
              ? e.description + (webcodecs ? ' (auto — WebCodecs supported)' : '')
              : e.id === 'ffmpeg' && !webcodecs
              ? e.description + ' (auto — WebCodecs not supported)'
              : e.description
          }
        >
          {e.label}
        </button>
      ))}
    </div>
  )
}

export default EnginePicker
